import { useCallback, useState } from 'react';
import { IJob } from '~/domain/Jobs/types/jobsTypes';
import { useUserSelector } from '~/hooks/useUserSelector';
import { WorkerClassificationTypeEnum } from '~/models';

export const useJobSelection = (jobs: IJob[]) => {
  const [checkedJobs, setCheckedJobs] = useState<Record<string, boolean>>({});
  const { workerClassification } = useUserSelector();

  const isContractor =
    workerClassification?.classificationType === WorkerClassificationTypeEnum.Contractor;
  const isEmployee =
    workerClassification?.classificationType === WorkerClassificationTypeEnum.Employee;

  const hasSelection = Object.keys(checkedJobs).length > 0;
  const selectedJobIds = Object.keys(checkedJobs);
  const totalCheckedJobs = selectedJobIds.length;

  const handleToggleOption = useCallback(
    (jobId?: string) => {
      setCheckedJobs((prev) => {
        if (isContractor) {
          if (!jobId) {
            return Object.keys(prev).length === jobs.length
              ? {}
              : jobs.reduce((acc: Record<string, boolean>, job: IJob) => {
                  acc[job.id] = true;
                  return acc;
                }, {});
          }

          const newCheckedJobs = { ...prev };
          if (newCheckedJobs[jobId]) {
            delete newCheckedJobs[jobId];
          } else {
            newCheckedJobs[jobId] = true;
          }

          return newCheckedJobs;
        }

        return { [jobId!]: true };
      });
    },
    [isContractor, jobs],
  );

  const clearCheckedJobs = useCallback(() => {
    setCheckedJobs({});
  }, []);

  return {
    checkedJobs,
    hasSelection,
    totalCheckedJobs,
    handleToggleOption,
    isMultipleSelection: isContractor && !isEmployee,
    selectedJobIds,
    clearCheckedJobs,
  };
};
